class HomeScripts {
	constructor() {
        jQuery(document).ready(function($) {
            // Slide Principal
            var homeSlider = new Swiper('.home-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
            
            $('#slides').on('click', 'a', function(){
                const v = $(this).attr('href');
                if (v == '#quiz') {
                    HSOverlay.getInstance('#gaia-quiz', true).element.open();
                    return;
                }
            })

            // AJAX paginação de produtos
            $('.gaia_load_more').on('click', function() {
                var button = $(this);
                var container = button.closest('.gaia_section_ajax');
                var currentPage = container.find('.gaia_grid_products').data('current-page');
                var maxPages = container.find('.gaia_grid_products').data('max-pages');
        
                // Atualiza o número da página
                var nextPage = parseInt(currentPage) + 1;
        
                // Desativa o botão enquanto a requisição está em andamento
                button.addClass('loading');
                
                // Faz a requisição AJAX
                $.ajax({
                    url: gaiaCustomData.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'gaia_load_more_products',
                        query: button.data('query'),
                        page: nextPage,
                    },
                    success: function(response) {
                        if (response.success) {
                            // Adiciona os novos produtos ao container
                            var newItems = $(response.data.html).hide();
                            container.find('.gaia_grid_products').append(newItems);
                            newItems.fadeIn('slow');
                            
                            // Atualiza o número da página atual
                            container.find('.gaia_grid_products').data('current-page', nextPage);

                            // Rolagem suave até os novos produtos inseridos
                            $('html, body').animate({
                                scrollTop: newItems.first().offset().top
                            }, 'slow');
        
                            // Oculta o botão de "Veja mais" se chegou ao máximo de páginas
                            if (nextPage >= maxPages) {
                                button.parent().hide();
                            }
                        } else {
                            console.log(t('home.error_load_more_products'));
                        }
                    },
                    error: function(error) {
                        console.log(error);
                    },
                    complete: function() {
                        // Remove a classe de loading e restaura o botão
                        button.removeClass('loading');
                    }
                });
            });
        });
    }
}

export default HomeScripts